import WidgetModule from "@eisinc/Overrides/Widgets/ProductList/ProductListStockedItemsFilter";

export * from "@eisinc/Overrides/Widgets/ProductList/ProductListStockedItemsFilter";

export default WidgetModule;
